export const HTTP_CODES = {
    TOO_MANY_REQUESTS: 429,
    OK: 200
};

export const LOG_LEVELS = {
    ERROR: 'error',
    WARN: 'warn',
    DEBUG: 'debug',
    INFO: 'info',
    NONE: 'none'
};

export function guid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = Math.random()*16|0,
            v = c === 'x' ? r : (r&0x3|0x8);
        return v.toString(16);
    });
}

export function extractFileExtension(filename) {
    if (!filename || filename.split('.').length < 2){
        return '';
    }
    return filename.split('.').pop();
}

export function calcRetryAfterMilliSeconds(response) {
    const retryAfter = response?.headers?.['retry-after'];

    if (retryAfter === null || retryAfter === undefined) {
        return 0;
    }

    const nval = Number(retryAfter);
    if (Number.isFinite(nval)) {
        return (nval || 1) * 1000;
    }

    const retryDateMS = Date.parse(retryAfter);
    if (Number.isNaN(retryDateMS)) {
        return 0;
    }

    return retryDateMS - Date.now();
}
